import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  max-height: 100vh;
  overflow-y: auto;
  padding-bottom: 6.5625rem; // footer size
`;
